(() => {
  'use strict';
  const root = document.querySelector('[data-f2w-local-sport]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const cityId = root.dataset.cityId;
  const sportId = root.dataset.sportId;
  const language = (root.dataset.language || 'NL').split('-')[0].toUpperCase();
  const token = root.dataset.storefrontToken;
  const domain = root.dataset.shopDomain;
  const ids = JSON.parse(root.querySelector('[data-f2w-local-ids]').textContent);
  const chunk = (arr, size) => Array.from({ length: Math.ceil(arr.length / size) }, (_, i) => arr.slice(i * size, (i + 1) * size));
  const unique = (arr) => [...new Set(arr.filter(Boolean))];
  const query = `query LocalSport($ids:[ID!]!,$language:LanguageCode!) @inContext(language:$language) {
    nodes(ids:$ids) { ... on Metaobject {
      id type onlineStoreUrl
      name:field(key:"name"){value}
      image:field(key:"resolved_image_url"){value}
      city:field(key:"city_reference"){reference{... on Metaobject{id}}}
      born:field(key:"birth_city"){reference{... on Metaobject{id}}}
      gym:field(key:"home_gym"){reference{... on Metaobject{id name:field(key:"name"){value} city:field(key:"city_reference"){reference{... on Metaobject{id}}}}}}
      sports:field(key:"sports"){references(first:250){nodes{... on Metaobject{id}}}}
      dateStart:field(key:"date_start"){value}
      dateEnd:field(key:"date_end"){value}
      isHistoric:field(key:"is_historic"){value}
    } }
  }`;
  const sections = ['gyms', 'fighters', 'trainers', 'venues', 'events'];
  const searchThreshold = 24;
  const countFormatter = new Intl.NumberFormat(root.dataset.language || 'nl');
  const formatCount = value => countFormatter.format(value);
  const resultText = (element, count) => `${formatCount(count)} ${element.dataset[count === 1 ? 'resultOne' : 'resultMany'] || ''}`.trim();
  const normalizeSearch = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  const resultState = new Map();
  const status = root.querySelector('[data-f2w-local-status]');
  const chapterButtons = [...root.querySelectorAll('[data-f2w-local-chip]')];
  const switchesPanels = chapterButtons.some(item => item.dataset.f2wLocalChip === 'intro');
  const chapterPanels = [...root.querySelectorAll('[data-f2w-local-section]')];
  function activate(group) {
    const button = chapterButtons.find(item => item.dataset.f2wLocalChip === group && !item.hidden);
    if (!button) return;
    chapterPanels.forEach(panel => { panel.hidden = panel.dataset.f2wLocalSection !== group; });
    chapterButtons.forEach(item => item.setAttribute('aria-selected', item === button ? 'true' : 'false'));
  }
  if (switchesPanels) {
    chapterButtons.forEach(button => {
      button.addEventListener('click', () => activate(button.dataset.f2wLocalChip));
    });
    activate('intro');
  }
  function element(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text != null) el.textContent = text;
    return el;
  }
  function typeMatches(node) {
    return (node.sports?.references?.nodes || []).some(s => s.id === sportId);
  }
  function reason(node) {
    if (node.born?.reference?.id === cityId) return root.dataset.labelBorn;
    if (node.gym?.reference?.city?.reference?.id === cityId) {
      const name = node.gym.reference.name?.value;
      return name ? `${root.dataset.labelGym}: ${name}` : root.dataset.labelGym;
    }
    return '';
  }
  function card(node, group) {
    const name = node.name?.value || '';
    const article = element('article', 'f2w-event-card');
    const link = element('a', 'f2w-event-card__link');
    link.href = node.onlineStoreUrl;
    const imageWrap = element('div', 'f2w-event-card__image');
    if (node.image?.value) {
      const image = element('img');
      image.src = node.image.value;
      image.alt = name;
      image.width = 900;
      image.height = 675;
      image.loading = 'lazy';
      image.decoding = 'async';
      imageWrap.appendChild(image);
    } else {
      const placeholder = element('div', 'f2w-event-card__image--placeholder');
      placeholder.appendChild(element('span', '', name.slice(0, 1)));
      imageWrap.appendChild(placeholder);
    }
    const body = element('div', 'f2w-event-card__body');
    const content = element('div', 'f2w-event-card__content');
    let detail = '';
    if (group === 'fighters' || group === 'trainers') detail = reason(node);
    if (group === 'events' && node.dateStart?.value) {
      const dateValue = node.dateStart.value.slice(0, 10);
      const date = /^\d{4}-\d{2}-\d{2}$/.test(dateValue) ? new Date(`${dateValue}T12:00:00Z`) : null;
      if (date && !Number.isNaN(date.getTime())) {
        detail = new Intl.DateTimeFormat(root.dataset.language || 'nl', { day:'numeric', month:'long', year:'numeric', timeZone:'UTC' }).format(date);
      }
    }
    if (detail) {
      const topline = element('div', 'f2w-event-card__topline');
      topline.appendChild(element('span', 'f2w-event-card__period', detail));
      content.appendChild(topline);
    }
    content.appendChild(element('h3', 'f2w-event-card__title', name));
    content.appendChild(element('span', 'f2w-event-card__view', root.dataset.labelView));
    body.appendChild(content);
    link.append(imageWrap, body);
    article.appendChild(link);
    return article;
  }
  function render(group, records) {
    const section = root.querySelector(`[data-f2w-local-section="${group}"]`);
    const grid = section?.querySelector('[data-f2w-local-results]');
    if (!grid) return;
    records.sort((a,b) => (a.name?.value || '').localeCompare(b.name?.value || '', document.documentElement.lang || 'nl'));
    const search = section.querySelector('[data-f2w-local-search]');
    const searchPanel = section.querySelector('[data-f2w-local-search-panel]');
    const total = section.querySelector('[data-f2w-local-total]');
    const totalWrap = section.querySelector('[data-f2w-local-total-wrap]');
    let current = resultState.get(group);
    if (!current) {
      current = {records, search: ''};
      resultState.set(group, current);
      if (search) search.addEventListener('input', () => {
        current.search = search.value;
        render(group, current.records);
      });
    }
    current.records = records;
    const term = normalizeSearch(current.search);
    const filtered = term ? records.filter(node => normalizeSearch(`${node.name?.value || ''} ${reason(node)}`).includes(term)) : records;
    if (searchPanel) searchPanel.hidden = !(records.length > searchThreshold || Boolean(current.search.trim()));
    grid.replaceChildren(...filtered.map(node => card(node, group)));
    if (total) total.textContent = resultText(total, filtered.length);
    if (totalWrap) totalWrap.hidden = false;
    if (!switchesPanels) section.hidden = records.length === 0;
    const chip = root.querySelector(`[data-f2w-local-chip="${group}"]`);
    if (chip) chip.hidden = !records.length;
    const count = root.querySelector(`[data-f2w-local-count="${group}"]`);
    if (count) { count.textContent = formatCount(records.length); count.closest('[data-f2w-local-fact]').hidden = !records.length; }
  }
  async function getNodes(groupIds) {
    const output = [];
    for (const batch of chunk(groupIds, 100)) {
      const response = await fetch(`https://${domain}/api/2024-10/graphql.json`, {
        method: 'POST', headers: {'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':token},
        body: JSON.stringify({query, variables:{ids:batch, language}})
      });
      if (!response.ok) throw new Error('Storefront request failed');
      const result = await response.json();
      if (result.errors?.length || !result.data?.nodes) throw new Error('Storefront response incomplete');
      output.push(...result.data.nodes.filter(Boolean));
    }
    return output;
  }
  async function start() {
    if (!token || !domain || !cityId || !sportId) throw new Error('Missing landing-page configuration');
    const gymIds = unique(ids.gyms || []);
    const gymNodes = await getNodes(gymIds);
    if (gymNodes.length !== gymIds.length) throw new Error('Gym records did not fully hydrate');
    const gyms = gymNodes.filter(node => node.type === 'sports_location' && node.onlineStoreUrl && node.city?.reference?.id === cityId && typeMatches(node));
    const people = await getNodes(unique([...(ids.fighters || []), ...(ids.trainers || [])]));
    const chapters = { gyms };
    for (const group of ['fighters','trainers']) {
      const type = group === 'fighters' ? 'fighter_profile' : 'trainer_profile';
      const allowed = new Set(ids[group] || []);
      chapters[group] = people.filter(node => allowed.has(node.id) && node.type === type && node.onlineStoreUrl && typeMatches(node) && reason(node));
    }
    const cityNodes = await getNodes(unique([...(ids.venues || []), ...(ids.events || [])]));
    const venues = new Set(ids.venues || []);
    const events = new Set(ids.events || []);
    chapters.venues = cityNodes.filter(node => venues.has(node.id) && node.type === 'venue' && node.onlineStoreUrl && node.city?.reference?.id === cityId);
    chapters.events = cityNodes.filter(node => {
      if (!events.has(node.id) || node.type !== 'event' || !node.onlineStoreUrl || node.city?.reference?.id !== cityId || !typeMatches(node)) return false;
      const historic = ['true', '1', 'yes'].includes(String(node.isHistoric?.value || '').toLowerCase());
      const date = node.dateEnd?.value || node.dateStart?.value || '';
      return !historic && /^\d{4}-\d{2}-\d{2}$/.test(date.slice(0,10));
    });
    for (const group of sections) render(group, chapters[group] || []);
    if (status) status.hidden = true;
  }
  start().catch(error => {
    console.warn('FightBase local sport landing:', error);
    if (status) { status.textContent = root.dataset.labelError; status.hidden = false; }
  });
})();

